import React from 'react';
import propTypes from 'prop-types';
import { Tbl, TblHead, TblBody } from '../../../components/Tbl';
import RowItem from './RowItem';
import { userSellHandbagConditions } from '../../../utils/userSell';

const dataHeader=[
  'No.','Product','Price','Updated','Status', 'Action'
];

const getBoxConditionLabel = boxCondition => {
  switch (boxCondition) {
    case 'SEMPURNA':
      return 'PERFECT BOX';
    case 'NO_BOX':
      return 'MISSING BOX';
    case 'CACAT':
      return 'DAMAGED BOX';
    default:
      return boxCondition || '-';
  }
};

class List extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _data: []
    }
  }
  componentWillReceiveProps(nextProps){
    if(!nextProps.isLoading && nextProps.isLoading != this.props.isLoading){
      this.setState({
        _data: nextProps.data
      })
    }
  }
  render (){
    return (
      <div className="table-responsive" ref={this.props.innerRefs}>
        <p className="mb-1 text-muted">
          Showing {this.props.data.length} items loaded.
        </p>
        <Tbl>
          <TblHead
            renderChildren={this.props.onRenderHeader}
          />
          <TblBody
            isLoad={this.props.isLoading}
            hasRow={this.props.data.length>0}
            columnCount={8}
            renderChildren={()=> {
              if(!this.props.isLoading&&this.props.statusCode===200){
                return (
                  this.props.data.map((item,index)=>{
                    const number = index + 1;
                    const inclusions = userSellHandbagConditions.filter(item => item.inclusions === true)
                      .map(item => item.name);
                    const defectsCount = item.defects.filter(item =>
                      item.value === true && !inclusions.includes(item.name.toLowerCase())
                    ).length;
                    const inclusionsCount = item.defects.filter(item =>
                      item.value === true && inclusions.includes(item.name.toLowerCase())
                    ).length;
                    const sneakerDefectCount = [
                      item.yellowing,
                      item.display_item,
                      item.missing_accessories,
                      // exclude sneakers_defect if already has defects list, always be true.
                      defectsCount === 0? item.sneakers_defect : false
                    ].filter(item => item === true).length
                    const boxCondition = getBoxConditionLabel(item.box_condition);
                    return (
                      <RowItem
                        key={item.id}
                        id={item.id}
                        rowId={number}
                        category={item.product_variant.product.category? item.product_variant.product.category.name: '-'}
                        productVariantId={item.product_variant_id}
                        displayName={item.product_variant.display_name}
                        SKU={item.product_variant.SKU}
                        colour={item.product_variant.colour}
                        userEmail={item.user.email}
                        qty={item.quantity}
                        sneakersCondition={item.sneakers_condition}
                        askingPrice={item.asking_price}
                        preOrder={item.pre_order}
                        preVerified={item.pre_verified}
                        isExpired={item.status === 'approved' ? item.is_expired: false}
                        size={item.size?item.size:undefined}
                        status={item.status}
                        isSellerHoliday={item.is_seller_holiday}
                        updatedAt={item.updated_at}
                        approvedAt={item.approved_at}
                        consignmentId={item.consignment_id}
                        rack={item.rack}
                        defaultRoute={this.props.defaultRoute}
                        defectsCount={defectsCount + sneakerDefectCount}
                        inclusionsCount={inclusionsCount}
                        requestType={item.request_type}
                        consignmentx={item.consignment}
                        boxCondition={boxCondition}
                        isNewNoDefect={item.is_new_no_defect}
                      />
                    )
                  })
                )
              }
              return null;
            }}
          />
        </Tbl>
      </div>
    )
  }
}
export default List;

List.propTypes = {
  statusCode: propTypes.any,
  defaultRoute: propTypes.string.isRequired,
  isLoading: propTypes.bool
}
List.defaultProps = {
}
